(() => {
  const initialized = new WeakSet();
  const buttonFor = (video) => video.closest('.banner').querySelector('.viscena-video-play');
  const showPlay = (video) => {
    const button = buttonFor(video);
    if (button && video.paused) button.hidden = false;
  };
  const play = (video) => {
    if (!video.isConnected || document.hidden || !video.paused) return;
    video.muted = true;
    try {
      const pending = video.play();
      if (pending && typeof pending.catch === 'function') pending.catch(() => showPlay(video));
    } catch (_) { showPlay(video); }
  };
  const videos = () => document.querySelectorAll('.viscena-homepage-video');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) play(entry.target); });
  }) : null;
  const initialize = () => {
    videos().forEach((video) => {
      if (initialized.has(video)) return;
      initialized.add(video);
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      // Also support browsers that ignore source media queries.
      const sources = video.querySelectorAll('source');
      const source = window.matchMedia('(max-width: 749px)').matches ? sources[0] : sources[1];
      if (source) video.src = source.src;
      const button = buttonFor(video);
      if (button) button.addEventListener('click', () => play(video));
      video.addEventListener('playing', () => { if (button) button.hidden = true; });
      video.addEventListener('pause', () => showPlay(video));
      video.addEventListener('error', () => showPlay(video));
      video.addEventListener('loadeddata', () => play(video), { once: true });
      video.addEventListener('canplay', () => play(video), { once: true });
      if (observer) observer.observe(video);
      play(video);
      window.setTimeout(() => showPlay(video), 4000);
    });
  };
  const resume = () => videos().forEach(play);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('pageshow', resume);
  document.addEventListener('touchend', resume, { passive: true });
  document.addEventListener('click', resume);
})();
